export function getCookie(key) {
  return decodeURIComponent(
    document.cookie.replace(
      new RegExp('(?:(?:^|.*;)\\s*' +
        // eslint-disable-next-line no-useless-escape
        encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
        '\\s*\\=\\s*([^;]*).*$)|^.*$'),
      '$1'
    )
  ) || null
}

export function secureHTTPSData(data) {
  for (let key in data) {
    // eslint-disable-next-line no-prototype-builtins
    if (!data.hasOwnProperty(key)) continue
    if (typeof data[key] === 'object') {
      secureHTTPSData(data[key])
    } else {
      if (data[key] && typeof data[key] === 'string') {
        if (data[key].startsWith('http://')) {
          data[key] = data[key].replace('http://', 'https://')
        }
      }
    }
  }
}
